(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Main = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
},{}],2:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
},{}],3:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
},{}],4:[function(require,module,exports){
module.exports = require("regenerator-runtime");

},{"regenerator-runtime":5}],5:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  typeof module === "object" ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],6:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var Calc = require('./calc/calc');

var utils = require('./_utils'); //const config = require('./_config');


var curPetType = '';
var curCalc;
var curResult;
var $SCOPE;
var $sliderList;
var curSlideIdx = 0;
var orRecommendationTemplate;
var dryFoodRecommendationTemplate;
var sachetRecommendationTemplate;
var dryFoodCarouselTemplate;
var dryFoodTemplate;
var sachetCarouselTemplate;
var sachetTemplate;
var tlModal;
/*
setTimeout(() => {
    Calc.Calcs['dog'].dryFoods.forEach((p) => {
        p.variations.forEach(v =>  {
            console.log(p.product+' '+v.product)
            console.log(lang.translate((p.product+' '+v.product).trim()))
        })
    })
    Calc.Calcs['cat'].dryFoods.forEach((p) => {
        p.variations.forEach(v =>  {
            console.log(p.product+' '+v.product)
            console.log(lang.translate((p.product+' '+v.product).trim()))
        })
    })
}, 1000)
*/

var steps = [// Step 1 - Start
// ---------------------------------------
{
  init: function init() {
    // Bts next step
    $SCOPE.find('.cz-step-1 .cz-next-step').off('click').on('click', function () {
      goToSlide(curSlideIdx + 1);
    });
    curResult = false;
    curPetType = '';
    curCalc = false;
  }
}, // Step 2 - Pet Type
// ---------------------------------------
{
  init: function init() {
    // Bt dog / cat
    $SCOPE.find('.cz-step-2 .cz-next-step').off('click').on('click', function () {
      var petType = $(this).attr('data-pet-type');

      if (petType && Calc.Calcs[petType]) {
        curPetType = petType;
        curResult = false;
        curCalc = Calc.Calcs[petType];
        goToSlide(curSlideIdx + 1);
      }
    });
  }
}, // Step 3 - Calc
// ---------------------------------------
{
  init: function init() {
    // Bt Calc
    $SCOPE.find('.cz-step-3 .cz-next-step').off('click').on('click', function () {
      var formData = getFormData($(this).closest('.cz-slider__item').find('form'));
      curResult = false;

      try {
        curResult = curCalc.getResult(formData);
        if (!curResult) throw '';
        console.log('Result', curResult);
      } catch (ex) {
        console.log(ex);

        if (/weight.*range/i.test(ex)) {
          showErrorModal('Intervalo de peso não disponível para cálculo.');
        } else if (/actual.*bigger.*adult.*weight/i.test(ex)) {
          showErrorModal('O peso atual não pode ser maior que o peso quando adulto.');
        } else {
          showErrorModal();
        }
      }

      if (curResult) goToSlide(curSlideIdx + 1);
    }); // Dog form setup

    setupDogForm($SCOPE.find('.cz-step-3[data-pet-type="dog"] form')); // Cat form setup

    setupCatForm($SCOPE.find('.cz-step-3[data-pet-type="cat"] form'));
  },
  setup: function setup() {
    // Reset forms
    $SCOPE.find('.cz-step-3 form').each(function () {
      this.reset();
    }); // Update fields

    updateFields($SCOPE.find('.cz-step-3[data-pet-type="' + curPetType + '"] form'));
    $SCOPE.find('.extra-field').val('').closest('.cz-input').addClass('cz-hidden'); // update visible form

    $SCOPE.find('.cz-step-3[data-pet-type]').addClass('cz-hidden');
    $SCOPE.find('.cz-step-3[data-pet-type="' + curPetType + '"]').removeClass('cz-hidden');
  }
}, // Step 4 - Result
// ---------------------------------------
{
  init: function init() {},
  setup: function setup() {
    var $step4 = $SCOPE.find('.cz-step-4'); // Scroll to top

    $step4.scrollTop(0);
    var diets = curResult.diets || {};
    var imgType = curResult.type == 'cat' ? 'gato' : 'cachorro';

    function formatNumber(number) {
      if (Number.isNaN(number)) return ''; //return Number.isInteger(number) ? number.toFixed(0) : number.toFixed(2).replace('.', ',').replace(/(,.+)0$/, '$1').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

      return Math.round(number).toFixed(0).replace(/(,.+)0$/, '$1').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    function formatNumberSachet(number) {
      if (Number.isNaN(number)) return '';
      return Number.isInteger(number) ? number.toFixed(0) : number.toFixed(1).replace('.', ',').replace(/(,.+)0$/, '$1').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    } // Result Dry


    var dryContainer = $step4.find('.cz-result__dry');
    var dryContainerList = dryContainer.find('.cz-result__list');
    dryContainer.addClass('cz-hidden');
    dryContainerList.html('');
    $.each(curResult.diets.dryFoods, function (dryType, dryDiet) {
      var dryItem = $(dryFoodRecommendationTemplate);
      var img = 'assets/images/alimentos/' + dryDiet.dryFood.image;
      dryItem.find('.cz-result__img').attr('src', img);
      dryItem.find('.cz-label').html(dryType);
      dryItem.find('.cz-result__title').html(dryDiet.dryFood.product || '');
      dryItem.find('.cz-result__weight').html(formatNumber(dryDiet.grams) + ' gramas por dia');
      if (!dryContainer.hasClass('cz-hidden')) dryContainerList.append(orRecommendationTemplate);
      dryContainer.removeClass('cz-hidden');
      dryContainerList.append(dryItem);
    }); // Result Wet

    var wetContainer = $step4.find('.cz-result__wet');
    var wetContainerList = wetContainer.find('.cz-result__list');
    wetContainer.addClass('cz-hidden');
    wetContainerList.html('');
    $.each(curResult.diets.sachets, function (sachetType, sachetDiet) {
      var sachetItem = $(sachetRecommendationTemplate);
      var img = 'assets/images/alimentos/' + sachetDiet.sachet.image;
      sachetItem.find('.cz-result__img').attr('src', img);
      sachetItem.find('.cz-label').html(sachetType);
      sachetItem.find('.cz-result__title').html(sachetDiet.sachet.product || '');
      sachetItem.find('.cz-result__weight').html(formatNumberSachet(sachetDiet.quantity) + ' sachê' + (sachetDiet.quantity > 1 ? 's' : '') + ' por dia');
      if (!wetContainer.hasClass('cz-hidden')) wetContainerList.append(orRecommendationTemplate);
      wetContainer.removeClass('cz-hidden');
      wetContainerList.append(sachetItem);
    }); // Products - Dry Food

    var dryFoodCarouselContainer = $step4.find('.cz-product-section__racao .cz-carousel__container');
    dryFoodCarouselContainer.html('');
    $step4.find('.cz-product-section__racao').addClass('cz-hidden');
    var carouselDryItems = [];
    $.each(curResult.dryFoods, function (dryType, product) {
      $.each(product.variations, function (i, variation) {
        var dryItem = $(dryFoodTemplate);

        if (variation.link && variation.link != '') {
          dryItem.find('.cz-carousel__link').attr('href', variation.link);
        } else {
          dryItem.find('.cz-carousel__link').removeAttr('href');
        }

        var img = 'assets/images/alimentos/' + (variation.image || product.image);
        dryItem.find('.cz-product__img').attr('src', img);
        dryItem.find('.cz-product__brand').html(dryType);
        dryItem.find('.cz-product__name').html(product.product + ' ' + variation.product);
        carouselDryItems.push(dryItem);
      });
    });

    if (carouselDryItems.length > 0) {
      dryFoodCarouselContainer.html(dryFoodCarouselTemplate);
      dryFoodCarouselContainer.find('.cz-carousel__list').append(carouselDryItems);
      $step4.find('.cz-product-section__racao').removeClass('cz-hidden');
      setupCarousel(dryFoodCarouselContainer);
    } // Products - Sachet


    var sachetCarouselContainer = $step4.find('.cz-product-section__sache .cz-carousel__container');
    sachetCarouselContainer.html('');
    $step4.find('.cz-product-section__sache').addClass('cz-hidden');
    var carouselSachetItems = [];
    $.each(curResult.sachets, function (sachetType, product) {
      $.each(product.variations, function (i, variation) {
        var sachetItem = $(sachetTemplate);

        if (variation.link && variation.link != '') {
          sachetItem.find('.cz-carousel__link').attr('href', variation.link);
        } else {
          sachetItem.find('.cz-carousel__link').removeAttr('href');
        }

        var img = 'assets/images/alimentos/' + (variation.image || product.image);
        sachetItem.find('.cz-product__img').attr('src', img);
        sachetItem.find('.cz-product__brand').html(sachetType);
        sachetItem.find('.cz-product__name').html(product.product + ' ' + variation.product);
        carouselSachetItems.push(sachetItem);
      });
    });

    if (carouselSachetItems.length > 0) {
      sachetCarouselContainer.html(sachetCarouselTemplate);
      sachetCarouselContainer.find('.cz-carousel__list').append(carouselSachetItems);
      $step4.find('.cz-product-section__sache').removeClass('cz-hidden');
      setupCarousel(sachetCarouselContainer);
    } // Carousel link buttons


    if ($step4.find('.cz-product-section__racao .cz-carousel__list .cz-carousel__item').length > 1) {
      $step4.find('.cz-view-dry-foods').removeClass('cz-hidden');
    } else {
      $step4.find('.cz-view-dry-foods').addClass('cz-hidden');
    }

    $step4.find('.cz-view-dry-foods').off('click').on('click', function () {
      $step4.find('.cz-product-section__racao').get(0).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });

    if ($step4.find('.cz-product-section__sache .cz-carousel__list .cz-carousel__item').length > 1) {
      $step4.find('.cz-view-sachets').removeClass('cz-hidden');
    } else {
      $step4.find('.cz-view-sachets').addClass('cz-hidden');
    }

    $step4.find('.cz-view-sachets').off('click').on('click', function () {
      $step4.find('.cz-product-section__sache').get(0).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    });
  }
}];

function setup() {
  $SCOPE = $('.cz-main');
  $sliderList = $SCOPE.find('.cz-slider__list'); // Templates

  orRecommendationTemplate = orRecommendationTemplate || $('#orRecommendationTemplate').html();
  $('#orRecommendationTemplate').remove();
  dryFoodRecommendationTemplate = dryFoodRecommendationTemplate || $('#dryFoodRecommendationTemplate').html();
  $('#dryFoodRecommendationTemplate').remove();
  sachetRecommendationTemplate = sachetRecommendationTemplate || $('#sachetRecommendationTemplate').html();
  dryFoodCarouselTemplate = dryFoodCarouselTemplate || $('#dryFoodCarouselTemplate').html();
  $('#dryFoodCarouselTemplate').remove();
  dryFoodTemplate = dryFoodTemplate || $('#dryFoodTemplate').html();
  $('#dryFoodTemplate').remove();
  sachetCarouselTemplate = sachetCarouselTemplate || $('#sachetCarouselTemplate').html();
  $('#sachetCarouselTemplate').remove();
  sachetTemplate = sachetTemplate || $('#sachetTemplate').html();
  $('#sachetTemplate').remove(); // Modal

  tlModal = new TimelineMax().reverse();
  tlModal.from($('.cz-modal'), .3, {
    autoAlpha: 0
  }, 0);
  tlModal.from($('.cz-modal__popup'), .3, {
    scale: 1.3
  }, 0);
  $('.cz-modal .cz-btn').off('click').on('click', hideErrorModal); // Bt back

  $SCOPE.find('.btn-voltar').off('click').on('click', function () {
    goToSlide(curSlideIdx - 1);
  }); // Bt Restart

  $SCOPE.find('.cz-restart').off('click').on('click', function () {
    goToSlide(0);
  }); // Bts prev step

  $SCOPE.find('.cz-back-step').off('click').on('click', function () {
    goToSlide(curSlideIdx - 1);
  }); // Init steps

  $.each(steps, function () {
    if ((0, _typeof2.default)(this.init == 'function')) this.init.call(this);
  });
  goToSlide(0);
}

function setupCarousel($sectionList) {
  $sectionList.find('.owl-carousel').each(function () {
    var carousel = $(this);
    if (carousel.data('initComplete')) return;
    carousel.data('initComplete', true);
    carousel.owlCarousel({
      margin: 0,
      responsiveClass: true,
      center: true,
      dots: false,
      //dotsContainer: '.container',
      nav: false,
      responsive: {
        0: {
          items: 1,
          startPosition: 0 //loop: carousel.find('.cz-carousel__item').length > 1,

        },
        969: {
          items: 3,
          startPosition: 1 //loop: carousel.find('.cz-carousel__item').length > 3,

        }
      }
    });
    carousel.closest('.cz-carousel').find('.cz-arrows__img--next').on('click', function () {
      console.log("NEXT");
      carousel.trigger('prev.owl.carousel');
    });
    carousel.closest('.cz-carousel').find('.cz-arrows__img--prev').on('click', function () {
      console.log("PREV");
      carousel.trigger('next.owl.carousel');
    });
  });
}

;

function goToSlide(idx) {
  idx = Math.max(0, Math.min(idx, steps.length - 1));
  var backward = curSlideIdx > idx;
  curSlideIdx = idx;

  if (curSlideIdx == 0) {
    $SCOPE.find('.btn-voltar').addClass('cz-hidden');
  } else {
    $SCOPE.find('.btn-voltar').removeClass('cz-hidden');
  }

  TweenMax.to($sliderList, .5, {
    xPercent: -100 * idx
  });
  $sliderList.find('.cz-slider__item--active').removeClass('cz-slider__item--active');
  if (!backward && typeof steps[idx].setup == 'function') steps[idx].setup.call(this);
  $sliderList.find('.cz-step-' + (idx + 1) + ':not(.cz-hidden)').addClass('cz-slider__item--active').find('img').on('load', function () {
    utils.sendHeightMessage(true);
  });
  utils.sendHeightMessage(true);
}

function getFormData($form) {
  var data = $form.serializeArray();
  var dataResult = {};

  for (var i = 0; i < data.length; i++) {
    dataResult[data[i].name] = data[i].value;
  }

  if (!(parseInt(dataResult.age_months) >= 0)) dataResult.age_months = 0;
  if (!(parseInt(dataResult.age_years) >= 0)) dataResult.age_years = 0;
  dataResult.age = parseInt(dataResult.age_years) * 12 + parseInt(dataResult.age_months);
  return dataResult;
}

function updateFields($form) {
  var formData = getFormData($form);
  var rule = curCalc.getRule(formData);
  $form.find('.extra-field').each(function () {
    if (rule && rule.requiredFields && rule.requiredFields.indexOf(this.name) >= 0) {
      $(this).closest('.cz-input').removeClass('cz-hidden');
    } else {
      $(this).val('').closest('.cz-input').addClass('cz-hidden');
    }
  });

  if (curPetType == 'dog') {
    if (!rule) {
      $form.find('[name="weight"]').siblings('label').html('Peso atual ou estimado quando adulto (Kg)');
    } else if (rule.name == 'puppy'
    /*|| !(formData.weight > 0)*/
    ) {
        $form.find('[name="weight"]').siblings('label').html('Peso estimado quando adulto (Kg)');
      } else {
      $form.find('[name="weight"]').siblings('label').html('Peso atual (Kg)');
    } // Special needs


    $form.find('[name="specialNeeds"]').closest('.cz-input').removeClass('cz-hidden');
    $form.find('[name="specialNeeds"] option').removeClass('cz-hidden');
    var ageRuleTest = curCalc.getRule($.extend({}, formData, {
      specialNeeds: ''
    }));

    if (ageRuleTest && ageRuleTest.name == 'puppy') {
      $form.find('[name="specialNeeds"]').val('').closest('.cz-input').addClass('cz-hidden');
    }

    if (ageRuleTest && ageRuleTest.name == 'senior') {
      $form.find('[name="specialNeeds"] option').each(function () {
        if (this.value != '' && this.value != 'light') $(this).addClass('cz-hidden');
      }); // if (['', 'light'].indexOf($form.find('[name="specialNeeds"]').val()) < 0) $form.find('[name="specialNeeds"]').val('');
    }

    if (formData.gender != 'female') {
      $form.find('[name="specialNeeds"] option').each(function () {
        if (this.value != '' && this.value != 'light') $(this).addClass('cz-hidden');
      }); // if (['light'].indexOf($form.find('[name="specialNeeds"]').val()) < 0) $form.find('[name="specialNeeds"]').val('');
    }

    if ($form.find('[name="specialNeeds"] option:selected').hasClass('cz-hidden')) $form.find('[name="specialNeeds"]').val('');
  } else if (curPetType == 'cat') {
    if (!rule) {
      $form.find('[name="weight"]').siblings('label').html('Peso atual ou estimado quando adulto (Kg)');
    } else if (rule.name == 'puppy'
    /*|| !(formData.weight > 0)*/
    ) {
        $form.find('[name="weight"]').siblings('label').html('Peso estimado quando adulto (Kg)');
      } else {
      $form.find('[name="weight"]').siblings('label').html('Peso atual (Kg)');
    } // Special needs


    $form.find('[name="specialNeeds"]').closest('.cz-input').removeClass('cz-hidden');
    $form.find('[name="specialNeeds"] option').removeClass('cz-hidden');
    var ageRuleTest = curCalc.getRule($.extend({}, formData, {
      specialNeeds: ''
    }));

    if (ageRuleTest && ageRuleTest.name == 'puppy') {
      $form.find('[name="specialNeeds"]').val('').closest('.cz-input').addClass('cz-hidden');
    }

    if (ageRuleTest && ageRuleTest.name == 'senior') {
      $form.find('[name="specialNeeds"] option').each(function () {
        if (this.value != '' && this.value != 'neutered') $(this).addClass('cz-hidden');
      });
      if (['neutered'].indexOf($form.find('[name="specialNeeds"]').val()) < 0) $form.find('[name="specialNeeds"]').val('');
    }

    if (formData.gender != 'female') {
      $form.find('[name="specialNeeds"] option').each(function () {
        if (this.value != '' && this.value != 'neutered') $(this).addClass('cz-hidden');
      });
      if (['neutered'].indexOf($form.find('[name="specialNeeds"]').val()) < 0) $form.find('[name="specialNeeds"]').val('');
    }

    var weightInput = $form.find('[name="weight"]');
    var minWeight = formData.bodyConditionScore == '6' ? 4 : 1;
    weightInput.attr('min', minWeight); //.val(Math.max(minWeight, Math.min(weightInput.val(), 12)));
  }
}

function setupDogForm($form) {
  // Add races
  function addDogRaces() {
    var selectedValue = $form.find('.select-dog-races').val();
    $form.find('.select-dog-races').html('');
    Calc.Calcs['dog'].races.forEach(function (r) {
      return r.label = lang.translate(r.name);
    });
    var dogRaces = Calc.Calcs['dog'].races.sort(function (a, b) {
      return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });
    dogRaces.push({
      name: "Another Breed",
      label: lang.translate("Another Breed")
    });
    $form.find('.select-dog-races').append(dogRaces.map(function (r) {
      return '<option value="' + r.name + '" lang="en">' + r.name + '</option>';
    }).join(''));
    $form.find('.select-dog-races').val(selectedValue);
  }

  addDogRaces();
  $(lang).on('afterUpdate', addDogRaces);
  $form.find('select, input').off('change keyup').on('change keyup', function () {
    updateFields($form);
  });
}

function setupCatForm($form) {
  // Add races
  function addCatRaces() {
    var selectedValue = $form.find('.select-cat-races').val();
    $form.find('.select-cat-races').html('');
    Calc.Calcs['cat'].races.forEach(function (r) {
      return r.label = lang.translate(r.name);
    });
    var catRaces = Calc.Calcs['cat'].races.sort(function (a, b) {
      if (a.name == 'No Defined Breed (NDB)') return 1;
      if (b.name == 'No Defined Breed (NDB)') return -1;
      return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
    });
    $form.find('.select-cat-races').append(catRaces.map(function (r) {
      return '<option value="' + r.name + '" lang="en">' + r.name + '</option>';
    }).join(''));
    $form.find('.select-cat-races').val(selectedValue);
  }

  addCatRaces();
  $(lang).on('afterUpdate', addCatRaces);
  $form.find('select, input').off('change keyup').on('change keyup', function () {
    updateFields($form);
  });
}

function showErrorModal(message) {
  if (!tlModal) return;
  message = message || 'Preencha todos os campos corretamente e tente novamente!';
  $('.cz-modal .cz-modal__text').html(message);

  if (!tlModal.isActive()) {
    tlModal.reversed(false);
  }
}

function hideErrorModal() {
  if (!tlModal) return;

  if (!tlModal.isActive()) {
    tlModal.reversed(true);
  }
}

module.exports = {
  setup: setup
};

},{"./_utils":8,"./calc/calc":11,"@babel/runtime/helpers/interopRequireDefault":2,"@babel/runtime/helpers/typeof":3}],7:[function(require,module,exports){
"use strict";

var Router = require('./router');

var router = new Router({
  mode: 'history',
  page404: function page404(path) {
    console.log(404, path);
    router.navigateTo('');
  }
}); // Global middleware

var loaded = false;
router.add(/.*/, function () {
  if (!loaded) return new Promise(function (resolve, reject) {
    $('#appContentWrapper').load('inc/home.html?c=' + Date.now(), function () {
      resolve(false);
    });
  });
  return Promise.resolve(false);
}); // Intro

router.add(/^index\.html$/, function () {
  router.redirectTo('');
});
router.add(/^$/, function () {
  // $('#appContentWrapper').load('inc/home.html', function() {
  document.dispatchEvent(new CustomEvent('pageLoaded', {
    detail: {
      page: router._currentPage
    }
  })); // });

  return true;
});
module.exports = router;

},{"./router":13}],8:[function(require,module,exports){
"use strict";

var appVersion = '999';
var platformId = '';

module.exports.isApp = function () {
  return typeof cordova !== 'undefined';
};

module.exports.openLink = function (url) {
  window.open(url, module.exports.isApp() && cordova.InAppBrowser ? '_system' : '_blank');
};

module.exports.getVersionInfo = function () {
  return {
    number: appVersion,
    origin: 'app',
    appmode: module.exports.isApp() ? 1 : 0,
    platformId: platformId
  };
};

module.exports.getAjaxRequestPostData = function (cmd, values) {
  var dataJSON = {
    cmd: cmd,
    values: values
  };
  var version = JSON.stringify(module.exports.getVersionInfo());
  return {
    appData: dataJSON,
    v: btoa(version),
    keyPass: 'DE270399-4465-4FAA-9C0A-23E4EA1C6E29'
  };
};

module.exports.getAjaxResponseData = function (response) {
  return response;
};

module.exports.ajaxRequest = function (url, cmd, values, callback, tries) {
  var cache = Math.random();
  var postData = module.exports.getAjaxRequestPostData(cmd, values);
  return $.ajax({
    url: url + "?cache=" + cache,
    cache: false,
    type: 'POST',
    contentType: 'application/json',
    dataType: 'json',
    //async: true,
    data: JSON.stringify(postData),
    timeout: 10000,
    success: function success(data) {
      if (data && data.serverResponse) {
        var result = module.exports.getAjaxResponseData(data.response);

        if (result && typeof callback == 'function' && !result.skipCallback) {
          callback(result);
        }
      }
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      tries = tries || 0;

      if (textStatus == 'error' && (!errorThrown || errorThrown == '') && tries < 1) {
        tries++;
        module.exports.ajaxRequest(url, cmd, values, callback, tries);
      } else {
        console.log('Erro ajaxRequest: ' + jqXHR.responseText + ', ' + textStatus + ', ' + errorThrown, jqXHR); // // Alert
        // notif({
        // 	msg: 'Erro! Verifique sua conexão e tente novamente.',
        // 	type: 'error',
        // 	position: 'bottom',
        // 	timeout: 3000,
        // 	bgcolor: '#DD6B55'
        // });
      }
    }
  });
};

var parentMessageEvent;
window.addEventListener("message", function (event) {
  if (!event.data) return;

  try {
    var object = JSON.parse(event.data);

    if (object.event == 'establishCommunication') {
      parentMessageEvent = event;
      module.exports.sendHeightMessage();
    } else if (object.event == 'get_height' && parentMessageEvent) {
      module.exports.sendHeightMessage();
    }
  } catch (ex) {}
}, false);

function sendActiveContentHeight() {
  var height = $('.cz-slider__item--active .cz-slider__holder').height();
  parentMessageEvent.source.postMessage(JSON.stringify({
    event: 'resize_iframe',
    height: height + 150 + 'px'
  }), parentMessageEvent.origin);
}

module.exports.sendHeightMessage = function (repeat) {
  if (!parentMessageEvent) return;
  setTimeout(sendActiveContentHeight);
  if (repeat) setTimeout(sendActiveContentHeight, 800);
}; /// ------------------------------------------------------------


if (module.exports.isApp() && cordova.getAppVersion) {
  cordova.getAppVersion.getVersionNumber().then(function (version) {
    return appVersion = version;
  });
}

platformId = (module.exports.isApp() ? cordova.platformId ? cordova.platformId : 'unknow' : 'browser').toLowerCase();

},{}],9:[function(require,module,exports){
"use strict";

/* Data: {
    age,
    weight,
    race,
    gender,
    specialNeeds (neutered, pregnant, lactating)
    ?bodyConditionScore (5 - Ideal weight, 6 - Overweight, 7 - Overweight),
    ?numberOfPuppies (1 - 20)
    ?lactationWeek (week 1 - 7)
}
*/
//let outputRange = {min: 0, max: 2000}
//let getWeigthSize = function(weigth) {
//    return weigth < 6 ? 'mini' : (weigth < 11 ? 'small' : (weigth < 26 ? 'medium' : (weigth < 45 ? 'big' : 'giant')));
//}
// RACES
// ----------------------------------------------------------------------------------------------------------
var races = [{
  "name": "Abyssinian",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  }
}, {
  "name": "Turkish Angora",
  "weight": {
    "m": [3, 5],
    "f": [3, 5]
  }
}, {
  "name": "Bengal",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  }
}, {
  "name": "Bombay",
  "weight": {
    "m": [2.5, 5],
    "f": [2.5, 5]
  }
}, {
  "name": "Norwegian Woods",
  "weight": {
    "m": [5.5, 7.5],
    "f": [4, 5.5]
  }
}, {
  "name": "British Shorthair",
  "weight": {
    "m": [4, 8],
    "f": [3.5, 5.5]
  }
}, {
  "name": "Burmilla",
  "weight": {
    "m": [4, 7],
    "f": [4, 7]
  }
}, {
  "name": "Chartreux",
  "weight": {
    "m": [3, 7.5],
    "f": [3, 7.5]
  }
}, {
  "name": "Cornish Rex",
  "weight": {
    "m": [2.5, 4.5],
    "f": [2.5, 4.5]
  }
}, {
  "name": "Devon Rex",
  "weight": {
    "m": [2.5, 4],
    "f": [2.5, 4]
  }
}, {
  "name": "Exotic Shorthair",
  "weight": {
    "m": [3, 6.5],
    "f": [3, 6.5]
  }
}, {
  "name": "Maine Coon",
  "weight": {
    "m": [6, 9],
    "f": [4, 6]
  }
}, {
  "name": "Oriental Shorthair",
  "weight": {
    "m": [4, 6.5],
    "f": [4, 6.5]
  }
}, {
  "name": "Persian",
  "weight": {
    "m": [4, 6],
    "f": [3, 5.5]
  }
}, {
  "name": "Ragdoll",
  "weight": {
    "m": [4.5, 9],
    "f": [4.5, 9]
  }
}, {
  "name": "Sacred of Burma",
  "weight": {
    "m": [4.5, 8],
    "f": [4.5, 8]
  }
}, {
  "name": "Scottish Fold",
  "weight": {
    "m": [2.5, 6],
    "f": [2.5, 6]
  }
}, {
  "name": "Siamese",
  "weight": {
    "m": [4.5, 7],
    "f": [3.5, 5.5]
  }
}, {
  "name": "Siberian",
  "weight": {
    "m": [4.5, 9],
    "f": [4.5, 9]
  }
}, {
  "name": "Somali",
  "weight": {
    "m": [3.5, 5],
    "f": [3.5, 5]
  }
}, {
  "name": "Sphynx",
  "weight": {
    "m": [4, 5],
    "f": [3, 4]
  }
}, {
  "name": "No Defined Breed (NDB)",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  } // }, {
  //     "name": "Outra Raça",
  //     "weight": {
  //         "m": [4, 4],
  //         "f": [4, 4]
  //     }

}]; // RULES
// ----------------------------------------------------------------------------------------------------------

var rules = {};
var rulesTestPriority = ['neutered', 'pregnant', 'lactating', 'puppy', 'senior', 'adult'];
/* Special Needs - Neutered */

rules.neutered = {
  name: 'neutered',
  data: {
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 75,
        exp: 0.67
      },
      7: {
        multiplier: 75,
        exp: 0.67
      }
    }
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'bodyConditionScore'],
  test: function test(data) {
    return data.specialNeeds === 'neutered' && !rules.puppy.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.neutered.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
};
/* Special Needs - Pregnant */

rules.pregnant = {
  name: 'pregnant',
  data: {
    multiplier: 140,
    exp: 0.67
  },
  requiredFields: ['weight', 'age', 'specialNeeds'],
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return Math.pow(data.weight, rules.pregnant.data.exp) * rules.pregnant.data.multiplier;
  }
};
/* Special Needs - Lactating */

rules.lactating = {
  name: 'lactating',
  data: {
    multiplier: 100,
    exp: 0.67,
    multipliers: {
      lactationWeek: {
        1: 0.9,
        2: 0.9,
        3: 1.2,
        4: 1.2,
        5: 1.1,
        6: 1,
        7: 0.8
      },
      puppiesRange: {
        1: 18,
        2: 60,
        3: 70
      }
    }
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'lactationWeek', 'numberOfPuppies'],
  test: function test(data) {
    return data.specialNeeds === 'lactating' && data.weight > 0 && data.age > 0 && rules.adult.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    if (!(data.lactationWeek > 0) || !rules.lactating.data.multipliers.lactationWeek[data.lactationWeek]) throw 'Inform a valid lactation week.';
    if (!(data.numberOfPuppies > 0)) throw 'Inform a valid number of puppies.';
    var puppiesRange = data.numberOfPuppies < 3 ? 1 : data.numberOfPuppies < 5 ? 2 : 3;
    var puppiesMult = rules.lactating.data.multipliers.puppiesRange[puppiesRange];
    var weekMult = rules.lactating.data.multipliers.lactationWeek[data.lactationWeek];
    var ne = Math.pow(data.weight, rules.lactating.data.exp) * rules.lactating.data.multiplier;
    return ne + puppiesMult * weekMult * data.weight;
  }
};
/* Puppy */

rules.puppy = {
  name: 'puppy',
  data: {
    maxAge: 11,
    multiplier: 100,
    exp: 0.67,
    c1: 6.732,
    c2: 2.718,
    c3: -0.189,
    c4: 0.66
  },
  requiredFields: ['weight', 'actualWeight', 'age', 'race', 'gender'],
  test: function test(data) {
    return data.weight > 0 && data.age > 0 && data.age <= rules.puppy.data.maxAge;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    if (!rules.puppy.test(data)) throw 'Inform a valid puppy data.';
    if (!(data.actualWeight > 0)) throw 'Inform a valid actual weight.';
    if (parseInt(data.weight) < parseInt(data.actualWeight)) throw 'Actual weight cannot be bigger than adult weight.';
    var weightRatio = data.actualWeight / data.weight;
    var puppyData = rules.puppy.data;
    return puppyData.multiplier * Math.pow(data.actualWeight, puppyData.exp) * puppyData.c1 * (Math.pow(puppyData.c2, puppyData.c3 * weightRatio) - puppyData.c4);
  }
};
/* Senior */

rules.senior = {
  name: 'senior',
  data: {
    minAge: 7 * 12,
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 130,
        exp: 0.4
      },
      7: {
        multiplier: 130,
        exp: 0.4
      }
    }
  },
  requiredFields: ['weight', 'age', 'bodyConditionScore'],
  test: function test(data) {
    return data.weight > 0 && data.age > 0 && data.age >= rules.senior.data.minAge;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.senior.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
};
/* Adult */

rules.adult = {
  name: 'adult',
  data: {
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 75,
        exp: 0.67
      },
      7: {
        multiplier: 75,
        exp: 0.67
      }
    }
  },
  requiredFields: ['weight', 'age', 'bodyConditionScore'],
  test: function test(data) {
    return data.weight > 0 && data.age > 0 && !rules.puppy.test(data) && !rules.senior.test(data) && data.age > 0;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.adult.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
}; // DRY FOODS
// ----------------------------------------------------------------------------------------------------------

var dryFoods = [// Neutered
{
  product: 'GRANPLUS GOURMET ADULT CAT NEUTERED',
  image: 'GP_Gourmet_Gato_Adulto_Castrado_Sabor_Ovelha_e_Arroz_FRONTAL.png',
  variations: [{
    //id: 183, 
    product: 'SHEEP & RICE',
    image: 'GP_Gourmet_Gato_Adulto_Castrado_Sabor_Ovelha_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-gato-castrado-ovelha-arroz/'
  }, {
    //id: 179, 
    product: 'TURKEY & RICE',
    image: 'GP_Gourmet_Gato_Adulto_Castrado_Sabor_Peru_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-gato-castrado-peru-arroz/'
  }, {
    //id: 186, 
    product: 'SALMON & CHICKEN',
    image: 'GP_Gourmet_Gato_Adulto_Castrado_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-gato-castrado-salmao-frango/'
  }],
  em: 3.6,
  type: 'Gourmet',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && (rules.adult.test(data) || rules.senior.test(data));
  }
}, {
  product: 'GRANPLUS ADULT CAT NEUTERED',
  image: 'GP_Menu_Gato_Adulto_Castrado_Sabor_Atum_e_Arroz_FRONTAL.png',
  variations: [{
    //id: 183, 
    product: 'TUNA & RICE',
    image: 'GP_Menu_Gato_Adulto_Castrado_Sabor_Atum_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-castrado-atum-arroz/'
  }, {
    //id: 179, 
    product: 'MEAT & RICE',
    image: 'GP_Menu_Gato_Adulto_Castrado_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-castrado-carne-arroz/'
  }, {
    //id: 186, 
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Gato_Adulto_Castrado_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-castrado-frango-arroz/'
  }, {
    //id: 186, 
    product: 'SALMON & RICE',
    image: 'GP_Menu_Gato_Adulto_Castrado_Sabor_Salmao_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-castrado-salmao-arroz/'
  }],
  em: 3.6,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Puppy lactating, Pregnant
{
  product: 'GRANPLUS PUPPY CAT',
  image: 'GP_Menu_Gato_Filhote_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 816,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Gato_Filhote_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-filhote-frango-arroz/'
  }],
  em: 4,
  type: 'Menu',
  test: function test(data) {
    return rules.puppy.test(data) || ['lactating', 'pregnant'].indexOf(data.specialNeeds) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, {
  product: 'GRANPLUS CHOICE PUPPY CAT',
  image: 'GP_Choice_Gato_Filhote_Sabor_Frango_e_Carne_FRONTAL.png',
  variations: [{
    // id: 816, 
    product: 'CHICKEN & MEAT',
    image: 'GP_Choice_Gato_Filhote_Sabor_Frango_e_Carne_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/choice-gato-filhote-frango-carne/'
  }],
  em: 3.5,
  type: 'Choice',
  test: function test(data) {
    return rules.puppy.test(data) || ['lactating', 'pregnant'].indexOf(data.specialNeeds) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, {
  product: 'GRANPLUS GOURMET PUPPY CAT',
  image: 'GP_Gourmet_Gato_Filhote_Sabor_Salmao_e_Frango_FRONTAL.png',
  variations: [{
    // id: 816, 
    product: 'SALMON & CHICKEN',
    image: 'GP_Gourmet_Gato_Filhote_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-gato-filhote-salmao-frango/'
  }],
  em: 3.7,
  type: 'Gourmet',
  test: function test(data) {
    return rules.puppy.test(data) || ['lactating', 'pregnant'].indexOf(data.specialNeeds) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Adult / Senior
{
  product: 'GRANPLUS ADULT CAT',
  image: 'GP_Menu_Gato_Adulto_Sabor_Carne_e_Arroz_FRONTAL.png',
  variations: [{
    id: 891,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Gato_Adulto_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-adulto-carne-arroz/'
  }, {
    //id: 176, 
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Gato_Adulto_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-adulto-frango-arroz/'
  }, {
    id: 882,
    product: 'SALMON & RICE',
    image: 'GP_Menu_Gato_Adulto_Sabor_Salmao_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-gato-adulto-salmao-arroz/'
  }],
  em: 3.95,
  type: 'Menu',
  test: function test(data) {
    return (rules.adult.test(data) || rules.senior.test(data)) && data.specialNeeds == '';
  }
}, {
  product: 'GRANPLUS CHOICE ADULT CAT',
  image: 'GP_Choice_Gato_Adulto_Sabor_Frango_e_Carne_FRONTAL.png',
  variations: [{
    // id: 891, 
    product: 'CHICKEN & MEAT',
    image: 'GP_Choice_Gato_Adulto_Sabor_Frango_e_Carne_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/choice-gato-adulto/'
  }],
  em: 3.75,
  type: 'Choice',
  test: function test(data) {
    return (rules.adult.test(data) || rules.senior.test(data)) && data.specialNeeds == '';
  }
}]; // SACHETS
// ----------------------------------------------------------------------------------------------------------

var sachets = [// Neutered
{
  product: 'GRANPLUS GOURMET HUMID FOOD ADULT CAT NEUTERED',
  image: 'GP_Sache_Gourmet_Gato_Adulto_Castrado_Sabor_Salmao_e_Frango_FRONTAL.png',
  variations: [{
    //id: -1, 
    product: 'SALMON & CHICKEN',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Castrado_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-sache-gato-castrado-salmao-frango/'
  }, {
    //id: -1, 
    product: 'CHICKEN',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Castrado_Sabor_Frango_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-sache-gato-castrado-frango/',

  }, {
    //id: -1, 
    product: 'SHEEP',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Castrado_Sabor_Ovelha_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-sache-gato-castrado-ovelha/'
  }],
  em: 0.7,
  grams: 85,
  type: 'Gourmet',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Puppy
{
  product: 'GRANPLUS GOURMET HUMID FOOD PUPPY CAT',
  image: 'GP_Sache_Gourmet_Gato_Filhote_Sabor_Frango_FRONTAL.png',
  variations: [{
    //id: -1, 
    product: 'CHICKEN',
    image: 'GP_Sache_Gourmet_Gato_Filhote_Sabor_Frango_FRONTAL.png' // link: 'https://granplus.com.br/produtos/groumet-sache-gato-filhote-frango/',

  }],
  em: 0.8,
  grams: 85,
  type: 'Gourmet',
  test: function test(data) {
    return rules.puppy.test(data); // || (['lactating', 'pregnant'].indexOf(data.specialNeeds) >= 0 && (rules.adult.test(data) || rules.senior.test(data)))
  }
}, // Adult/Senior
{
  product: 'GRANPLUS GOURMET HUMID FOOD ADULT CAT',
  image: 'GP_Sache_Gourmet_Gato_Adulto_Sabor_Atum_FRONTAL.png',
  variations: [{
    //id: -1, 
    product: 'TUNA',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Sabor_Atum_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-sache-gato-adulto-atum/',

  }, {
    //id: -1, 
    product: 'MEAT',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Sabor_Carne_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-sache-gato-adulto-carne/',

  }, {
    //id: -1, 
    product: 'SALMON',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Sabor_Salmao_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-sache-gato-adulto-salmao/',

  }, {
    //id: -1, 
    product: 'URINARY TRACT CHICKEN',
    image: 'GP_Sache_Gourmet_Gato_Adulto_Trato_Urinario_Sabor_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-sache-gato-trato-unirario-frango/'
  }],
  em: 0.75,
  grams: 85,
  type: 'Gourmet',
  test: function test(data) {
    return data.specialNeeds === '' && (rules.adult.test(data) || rules.senior.test(data));
  }
}];
dryFoods.forEach(function (f) {
  console.log(f.product); // f.variations.forEach(v => {
  //     console.log(f.product + ' ' + v.product)
  // })
});
sachets.forEach(function (f) {
  console.log(f.product); // f.variations.forEach(v => {
  //     console.log(f.product + ' ' + v.product)
  // })
}); // ----------------------------------------------------------------------------------------------------------

function getRule(data) {
  //data.size = getWeigthSize(data.weight);
  var rule;

  for (var i = 0; i < rulesTestPriority.length; i++) {
    var curRule = rulesTestPriority[i];

    if (rules[curRule] && rules[curRule].test && rules[curRule].test(data)) {
      rule = rules[curRule];
      console.log('Calculating as ' + curRule);
      break;
    }
  }

  return rule;
}

function roundSachets(sachets) {
  return Math.ceil(Math.round(sachets * 10) / 10 / 0.5) * 0.5;
}

function getResult(data) {
  var rule = getRule(data);
  if (!rule) throw 'Calculation rule not registered.';
  var dryFoodsOpts = {};
  dryFoods.forEach(function (dryFood) {
    if (!dryFoodsOpts[dryFood.type] && dryFood.em > 0 && dryFood.test(data)) dryFoodsOpts[dryFood.type] = dryFood;
  });
  var sachetsOpts = {};
  sachets.forEach(function (sachet) {
    if (!sachetsOpts[sachet.type] && sachet.em > 0 && sachet.test(data)) sachetsOpts[sachet.type] = sachet;
  });
  var result = {
    type: 'cat',
    rule: rule.name,
    nem: rule.getNEM(data),
    dryFoods: dryFoodsOpts,
    sachets: sachetsOpts,
    diets: {}
  };

  if (result.nem > 0) {
    // Dry
    $.each(dryFoodsOpts, function (f, dryFood) {
      result.diets.dryFoods = result.diets.dryFoods || {};
      if (result.diets.dryFoods[dryFood.type]) return;
      result.diets.dryFoods[dryFood.type] = {
        dryFood: dryFood,
        grams: result.nem / dryFood.em
      };
    }); // Sachet

    $.each(sachetsOpts, function (s, sachet) {
      result.diets.sachets = result.diets.sachets || {};
      if (result.diets.sachets[sachet.type]) return;
      result.diets.sachets[sachet.type] = {
        sachet: sachet,
        quantity: Math.max(0.5, roundSachets(result.nem / sachet.em / sachet.grams))
      };
    });
  }

  console.log(result);
  return result;
}

module.exports = {
  brand: 'GP',
  name: 'gato',
  getRule: getRule,
  getResult: getResult,
  races: races //rules: rules,
  //dryFoods: dryFoods,
  //sachets: sachets,

};

},{}],10:[function(require,module,exports){
"use strict";

/* Data: {
    age,
    weight,
    *race,
    specialNeeds (light, sensitive, pregnant, lactating)
    ?activity (low, medium, high)
    ?bodyConditionScore (5 - Ideal weight, 6 - Overweight, 7 - Overweight),
    ?pregnancyPeriod (1 - Less or equal 4 weeks, 2 - 4 weeks or more),
    ?numberOfPuppies (1 - 20)
    ?lactationWeek (week 1 - 7)
}
*/
//let outputRange = {min: 0, max: 2000}
var getWeigthSize = function getWeigthSize(weigth) {
  return weigth < 6 ? 'mini' : weigth < 11 ? 'small' : weigth < 26 ? 'medium' : weigth < 45 ? 'big' : 'giant';
}; // RACES
// ----------------------------------------------------------------------------------------------------------

/*
let races = [
    { "name": "Akita Inu" },
    { "name": "Beagle" },
    { "name": "Beagle Harrier" },
    { "name": "Bobtail" },
    { "name": "Boiadeiro de Berna" },
    { "name": "Boxer" },
    { "name": "Braco Alemão" },
    { "name": "Braco Francês" },
    { "name": "Bull Terrier Inglês" },
    { "name": "Bulldog Americano" },
    { "name": "Bulldog Inglês" },
    { "name": "Cairn Terrier" },
    { "name": "Cane Corso" },
    { "name": "Caniche" },
    { "name": "Cão d’Água Espanhol" },
    { "name": "Cão de Crista Chinês" },
    { "name": "Cão Lobo Checoslovaco" },
    { "name": "Cavalier King Charles Spaniel" },
    { "name": "Chihuahua" },
    { "name": "Chow-Chow" },
    { "name": "Cocker Americano" },
    { "name": "Cocker Spaniel Inglês" },
    { "name": "Collie" },
    { "name": "Dálmata" },
    { "name": "Doberman" },
    { "name": "Dogue Alemão" },
    { "name": "Dogue de Bordéus" },
    { "name": "Epagneul Bretão" },
    { "name": "Fila Brasileiro" },
    { "name": "Fox Terrier" },
    { "name": "Galgo Afegão" },
    { "name": "Golden Retriever" },
    { "name": "Husky Siberiano" },
    { "name": "Ibizan Hound" },
    { "name": "Jack Russel Terrier" },
    { "name": "Lhasa Apso" },
    { "name": "Mastiff" },
    { "name": "Mastim dos Pirenéus" },
    { "name": "Mastim Espanhol" },
    { "name": "Mastim Napolitano" },
    { "name": "Norfolk Terrier" },
    { "name": "Papillon" },
    { "name": "Pastor Alemão" },
    { "name": "Pastor de Beauce" },
    { "name": "Pequeno Basset Griffon" },
    { "name": "Pequeno Brabançon" },
    { "name": "Pequeno Cão Leão" },
    { "name": "Pequinês" },
    { "name": "Perdigueiro Português" },
    { "name": "Pinscher Anão" },
    { "name": "Pitbull" },
    { "name": "Rottweiler" },
    { "name": "Samoiedo" },
    { "name": "São Bernardo" },
    { "name": "Schnauzer" },
    { "name": "Setter Inglês" },
    { "name": "Setter Irlandês" },
    { "name": "Shar Pei" },
    { "name": "Shih Tzu" },
    { "name": "Spaniel Japonês" },
    { "name": "Spitz Alemão" },
    { "name": "Staffordshire Bull Terrier" },
    { "name": "Teckel" },
    { "name": "Terranova" },
    { "name": "Terrier Brasileiro" },
    { "name": "Vizsla" },
    { "name": "Waimaraner" },
    { "name": "West Highland White Terrier" },
    { "name": "Yorkshire Terrier" },
    { "name": "Sem raça definida (SRD)" }
];
*/


var races = [{
  "name": "Afghan Greyhound"
}, {
  "name": "Aidi"
}, {
  "name": "Airedale Terrier"
}, {
  "name": "Akita"
}, {
  "name": "Alaska Malamute"
}, {
  "name": "Alpine Basset"
}, {
  "name": "American Bulldog"
}, {
  "name": "American Bully"
}, {
  "name": "American Foxhound"
}, {
  "name": "American Pit Bull Terrier"
}, {
  "name": "American Spaniel Cocker"
}, {
  "name": "American Staffordshire Terrier"
}, {
  "name": "American Water Dog"
}, {
  "name": "Argentine Doggo"
}, {
  "name": "Ariege Braco"
}, {
  "name": "Artois Dog"
}, {
  "name": "Australian Cattle Dog"
}, {
  "name": "Australian Shepherd"
}, {
  "name": "Australian Terrier"
}, {
  "name": "Austrian Black Hound and Fire"
}, {
  "name": "Auvergne's Braco"
}, {
  "name": "Azawakh"
}, {
  "name": "Barbet"
}, {
  "name": "Basenji"
}, {
  "name": "Basset Hound"
}, {
  "name": "Beagle Harrier"
}, {
  "name": "Beagle"
}, {
  "name": "Bearded Collie"
}, {
  "name": "Bedlington Terrier"
}, {
  "name": "Belgian Groenendael Shepherd"
}, {
  "name": "Belgian Malinois Shepherd"
}, {
  "name": "Belgium Griffon"
}, {
  "name": "Bergamasco Shepherd"
}, {
  "name": "Bergamo Shepherd"
}, {
  "name": "Bernese Mountain Dog"
}, {
  "name": "Bestiar Dog"
}, {
  "name": "Bichon Bolognese"
}, {
  "name": "Bichon Frize"
}, {
  "name": "Biewer"
}, {
  "name": "Billy"
}, {
  "name": "Black and Brown Coonhound"
}, {
  "name": "Black and Brown Miniature Terrier"
}, {
  "name": "Black Coonhound and Fire"
}, {
  "name": "Bloodhound"
}, {
  "name": "Blue Basset of Gascony"
}, {
  "name": "Blue Hiller"
}, {
  "name": "Border Collie"
}, {
  "name": "Border Terrier"
}, {
  "name": "Borzoi"
}, {
  "name": "Boston Terrier"
}, {
  "name": "Bourbon Braco"
}, {
  "name": "Boxer"
}, {
  "name": "Brazilian Fila"
}, {
  "name": "Brazilian Terrier"
}, {
  "name": "british spaniel"
}, {
  "name": "Brittany Fawn Griffin"
}, {
  "name": "Broholmer"
}, {
  "name": "Brussels Griffon"
}, {
  "name": "Bull Terrier"
}, {
  "name": "Bullmastiff"
}, {
  "name": "Cairn Terrier"
}, {
  "name": "Canaã Dog"
}, {
  "name": "Canadian Eskimo (Esquimau)"
}, {
  "name": "Canary Doggo"
}, {
  "name": "Cane Corso"
}, {
  "name": "Catalan Shepherd"
}, {
  "name": "Cavalier King Charles Spaniel"
}, {
  "name": "Chesapeake Bay Retriever"
}, {
  "name": "Chihuahua"
}, {
  "name": "Chinese Crested Dog"
}, {
  "name": "Chow Chow"
}, {
  "name": "Collie Long Hair"
}, {
  "name": "Collie Short Hair"
}, {
  "name": "Continental Dwarf Spaniel"
}, {
  "name": "Coton de Tulear"
}, {
  "name": "Coton Tulear"
}, {
  "name": "Country Bulldog"
}, {
  "name": "Cowboy"
}, {
  "name": "Croatian Shepherd"
}, {
  "name": "Curly Haired Retriever"
}, {
  "name": "Czech Terrier"
}, {
  "name": "Dachshund"
}, {
  "name": "Dalmatian"
}, {
  "name": "Dandie Dinmont Terrier"
}, {
  "name": "Dingo (Haliki, Warrigal, Noggum, Boolomo)"
}, {
  "name": "Doberman"
}, {
  "name": "Dogue de Bordeaux"
}, {
  "name": "Drenthe Partridge Spaniel"
}, {
  "name": "Drever"
}, {
  "name": "Dutch Shepherd"
}, {
  "name": "Dwarf Eskimo of America"
}, {
  "name": "English Bulldog"
}, {
  "name": "English Foxhound"
}, {
  "name": "English Seter"
}, {
  "name": "English Spaniel Cocker"
}, {
  "name": "English Spaniel Springer"
}, {
  "name": "English Springer"
}, {
  "name": "Engllish Toy Terrier"
}, {
  "name": "Eurasian Dog"
}, {
  "name": "Field Spaniel"
}, {
  "name": "Finnish Hound"
}, {
  "name": "Finnish Shepherd of Lapland"
}, {
  "name": "Finnish Spitz"
}, {
  "name": "Flat Coated Retriever"
}, {
  "name": "Flat Fur Retriever"
}, {
  "name": "Fox Terrier"
}, {
  "name": "French Bulldog"
}, {
  "name": "French Spaniel"
}, {
  "name": "French"
}, {
  "name": "Frision Water Dog"
}, {
  "name": "Gascogne-type French Braco"
}, {
  "name": "Gascon Saintongeois"
}, {
  "name": "German Braco"
}, {
  "name": "German Hound"
}, {
  "name": "German Pointer"
}, {
  "name": "German Shepherd"
}, {
  "name": "German Spitz/Pomeranian Lulu"
}, {
  "name": "Giant Schnauzer"
}, {
  "name": "Golden Retriever"
}, {
  "name": "Gordon Setter"
}, {
  "name": "Great Dane of Tibet"
}, {
  "name": "Great Dane"
}, {
  "name": "Great Swiss Cattleman"
}, {
  "name": "Greyhound"
}, {
  "name": "Greyster (Norway)"
}, {
  "name": "Griffon Nivernais"
}, {
  "name": "Halden's Hound"
}, {
  "name": "Hamilton Hound"
}, {
  "name": "Hamiltonstovare"
}, {
  "name": "Hanover"
}, {
  "name": "Havanese Bichon"
}, {
  "name": "Hokkaido"
}, {
  "name": "Hovawart"
}, {
  "name": "Hungarian Greyhound"
}, {
  "name": "Hygen Hound"
}, {
  "name": "Iceland Dog"
}, {
  "name": "Irish Glen of Imaal Terrier"
}, {
  "name": "Irish Greyhound"
}, {
  "name": "Irish Seter"
}, {
  "name": "Irish Soft Coated Wheaten Terrier"
}, {
  "name": "Irish Terrier"
}, {
  "name": "Irish Water Dog"
}, {
  "name": "Irish Wolfhound"
}, {
  "name": "Istrian Hound"
}, {
  "name": "Italian Braco"
}, {
  "name": "Italian Greyhound"
}, {
  "name": "Italian Hound"
}, {
  "name": "Italian Spitz"
}, {
  "name": "Italian Vulpine"
}, {
  "name": "Jack Russell Terrier"
}, {
  "name": "Jagdterrier"
}, {
  "name": "Japanese Spaniel"
}, {
  "name": "Japanese Spitz"
}, {
  "name": "Japanese Terrier"
}, {
  "name": "Kai"
}, {
  "name": "Kelpie"
}, {
  "name": "Kerry Beagle (Pocadan)"
}, {
  "name": "Kerry Blue Terrier"
}, {
  "name": "King Charles Spaniel"
}, {
  "name": "Kishu"
}, {
  "name": "Komondor"
}, {
  "name": "Korean Jindo Dog"
}, {
  "name": "Krast Hillside Shepherd"
}, {
  "name": "Kromfohrlander"
}, {
  "name": "Kuvasz"
}, {
  "name": "Kyi Apso (Bearded Tibetan Great Dane)"
}, {
  "name": "Kyi Leo"
}, {
  "name": "Labradoodle (Australia)"
}, {
  "name": "Labrador Retriever"
}, {
  "name": "Lagotto Romagnolo"
}, {
  "name": "Laica"
}, {
  "name": "Laika"
}, {
  "name": "Lakeland Terrier"
}, {
  "name": "Lancashire Heeler (Ormskirk Terrier)"
}, {
  "name": "Landseer"
}, {
  "name": "Leonberger"
}, {
  "name": "Lhasa Apso"
}, {
  "name": "Little Italian Greyhound"
}, {
  "name": "Little Lion Dog"
}, {
  "name": "Lucas Terrier (Great Britain)"
}, {
  "name": "Lurcher (Great Britain)"
}, {
  "name": "Majestic Tree Hound (United States)"
}, {
  "name": "Majorcan Dogue"
}, {
  "name": "Maltese"
}, {
  "name": "Manchester Terrier"
}, {
  "name": "Maremmano Abruzes Shepherd"
}, {
  "name": "Mastiff"
}, {
  "name": "Medium Schnauzer"
}, {
  "name": "Meridional Russia Shepherd"
}, {
  "name": "Mexican Naked"
}, {
  "name": "Miniature Schnauzer"
}, {
  "name": "Mountain Cur (United States)"
}, {
  "name": "Mudi"
}, {
  "name": "Munster Spaniel"
}, {
  "name": "Napolitan Mastim"
}, {
  "name": "Napolitan Mastino"
}, {
  "name": "New Land"
}, {
  "name": "New Scotia Retriever"
}, {
  "name": "New Zeland Huntaway"
}, {
  "name": "Norboten Spitz"
}, {
  "name": "Norfolk Terrier"
}, {
  "name": "Norman Artesian Basset"
}, {
  "name": "Norwegian Buhund"
}, {
  "name": "Norwegian Dog"
}, {
  "name": "Norwegian Elkhound (Black)"
}, {
  "name": "Norwegian Hound"
}, {
  "name": "Norwich Terrier"
}, {
  "name": "Old English Brazilian Bulldogge"
}, {
  "name": "Old English Bulldog"
}, {
  "name": "Old English Sheepdog"
}, {
  "name": "Papillon"
}, {
  "name": "Patterdale Terrier (Black Fell-Terrier)"
}, {
  "name": "Pekingese"
}, {
  "name": "Peruvian Naked"
}, {
  "name": "Picardy Blue Spaniel"
}, {
  "name": "Picardy Spaniel"
}, {
  "name": "Pinscher"
}, {
  "name": "Pitbull"
}, {
  "name": "Plain Polish Shepherd"
}, {
  "name": "Plott Hound"
}, {
  "name": "Plummer Terrier"
}, {
  "name": "Pointer"
}, {
  "name": "Poitevin"
}, {
  "name": "Polish Hound"
}, {
  "name": "Polonese Greyhound"
}, {
  "name": "Pont-Audemer Spaniel"
}, {
  "name": "Poodle"
}, {
  "name": "Porcelana"
}, {
  "name": "Portuguese Podengo"
}, {
  "name": "Portuguese Water Dog"
}, {
  "name": "Posavatz Hound"
}, {
  "name": "Prazky Krysavick"
}, {
  "name": "Pudelpointer"
}, {
  "name": "Pug"
}, {
  "name": "Puli"
}, {
  "name": "Pumi"
}, {
  "name": "Pyrenean Mastiff"
}, {
  "name": "Pyrenees-type French Braco"
}, {
  "name": "Rafeiro do Alentejo"
}, {
  "name": "Rampur Hen (India)"
}, {
  "name": "Rastreador Brasileiro"
}, {
  "name": "Redbone Coonhound"
}, {
  "name": "Redtick Coonhound"
}, {
  "name": "Rhodesian Ridgeback (Rhodesian Dorsal Crested Dog)"
}, {
  "name": "Rottweiler"
}, {
  "name": "Russian Black Terrier"
}, {
  "name": "Saint Germain Braco"
}, {
  "name": "Saint-Usuge Spaniel"
}, {
  "name": "Saluki"
}, {
  "name": "Samoieda"
}, {
  "name": "Sanshu"
}, {
  "name": "Sarplaninac"
}, {
  "name": "Schapendoes"
}, {
  "name": "Schiller's Hound"
}, {
  "name": "Schipperke"
}, {
  "name": "Scotch Greyhound"
}, {
  "name": "Scottish Terrier"
}, {
  "name": "Sealyham Terrier"
}, {
  "name": "Seter Gordon"
}, {
  "name": "Shar Pei"
}, {
  "name": "Shepherd of Anatolia"
}, {
  "name": "Shepherd of Beauce"
}, {
  "name": "Shepherd of Brie"
}, {
  "name": "Shepherd of Central Asia"
}, {
  "name": "Shepherd of Maremma and the Abruzzi"
}, {
  "name": "Shepherd of North America"
}, {
  "name": "Shepherd of Picardy"
}, {
  "name": "Shepherd of Pireneus"
}, {
  "name": "Shepherd of Russia"
}, {
  "name": "Shepherd of Shetland"
}, {
  "name": "Shiba"
}, {
  "name": "Shih Tzu"
}, {
  "name": "Shiloh Shepherd"
}, {
  "name": "Siberian Husky"
}, {
  "name": "Silky Terrier"
}, {
  "name": "Skye Terrier"
}, {
  "name": "Sloughi"
}, {
  "name": "Slougi"
}, {
  "name": "Slovak Cuvac"
}, {
  "name": "slovak hound"
}, {
  "name": "Slovak Tchouvatch"
}, {
  "name": "Smaland Hound"
}, {
  "name": "Smaland stovare"
}, {
  "name": "Small Dutch Dog"
}, {
  "name": "Small Dutch Water Hound"
}, {
  "name": "Smooth Haired Retriever"
}, {
  "name": "Smoushond"
}, {
  "name": "Spanish Greyhound"
}, {
  "name": "Spanish Hound"
}, {
  "name": "Spanish Mastim"
}, {
  "name": "Spanish Water Dog"
}, {
  "name": "Spinone Italiano"
}, {
  "name": "Spitz of the Visigoths"
}, {
  "name": "St Bernard"
}, {
  "name": "Stabyhoun"
}, {
  "name": "Staffordshire Bull Terrier"
}, {
  "name": "Standard Schnauzer"
}, {
  "name": "Star Mountain Dog"
}, {
  "name": "Sussex Spaniel"
}, {
  "name": "Swiss Hound"
}, {
  "name": "Swiss Hounds"
}, {
  "name": "Thai Dorsal Crested Dog"
}, {
  "name": "Tibetan Spaniel"
}, {
  "name": "Tibetan Terrier"
}, {
  "name": "Tosa"
}, {
  "name": "Treeing Walker Coonhoud"
}, {
  "name": "Trigg-Hound"
}, {
  "name": "Tyrolean Hound"
}, {
  "name": "Vendee Griffin"
}, {
  "name": "Viszla"
}, {
  "name": "Wavy Haired Retriever"
}, {
  "name": "Weimaraner"
}, {
  "name": "Welch Terrier"
}, {
  "name": "Welsh Corgi"
}, {
  "name": "Welsh Springer"
}, {
  "name": "Welsh Terrier"
}, {
  "name": "West Highland White Terrier"
}, {
  "name": "Westphalian German Basset"
}, {
  "name": "Whippet"
}, {
  "name": "White Shepherd"
}, {
  "name": "White Swiss Shepherd"
}, {
  "name": "Wirehaired Slovak Pointing Gryphon"
}, {
  "name": "Woolly fur Griffon"
}, {
  "name": "York Chocolat"
}, {
  "name": "Yorkshire Terrier"
}, {
  "name": "Yugoslavian Tricolor Hounds"
}, {
  "name": "No Defined Breed (NDB)"
}]; // RULES
// ----------------------------------------------------------------------------------------------------------

var rules = {};
var rulesTestPriority = ['light', 'pregnant', 'lactating', 'puppy', 'senior', 'adult'];
/* Special Needs - Light */

rules.light = {
  name: 'light',
  data: {
    multiplier: 95,
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds'],
  test: function test(data) {
    return data.specialNeeds === 'light' && data.weight > 0 && data.age > 0 && !rules.puppy.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return Math.pow(data.weight, rules.light.data.exp) * rules.light.data.multiplier;
  }
};
/* Special Needs - Pregnant */

rules.pregnant = {
  name: 'pregnant',
  data: {
    pregnancyPeriod: {
      1: {
        multiplier: 132,
        addMultiplier: 0
      },
      2: {
        multiplier: 132,
        addMultiplier: 26
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'pregnancyPeriod'],
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && data.weight > 0 && data.age > 0 && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var periodData = rules.pregnant.data.pregnancyPeriod[data.pregnancyPeriod];
    if (!periodData) throw 'Inform a valid pregnancy period.';
    return Math.pow(data.weight, rules.pregnant.data.exp) * periodData.multiplier + data.weight * periodData.addMultiplier;
  }
};
/* Special Needs - Lactating */

rules.lactating = {
  name: 'lactating',
  data: {
    lactationWeekMultiplier: {
      1: 0.75,
      2: 0.95,
      3: 1.1,
      4: 1.2
    },
    multiplier: 145,
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'lactationWeek', 'numberOfPuppies'],
  test: function test(data) {
    return data.specialNeeds === 'lactating' && data.weight > 0 && data.age > 0 && rules.adult.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var calcData = rules.lactating.data;
    if (!calcData.lactationWeekMultiplier[data.lactationWeek]) throw 'Inform a valid lactation week.';
    var n = Math.min(4, data.numberOfPuppies);
    var m = Math.max(data.numberOfPuppies - n, 0);
    var c = 24 * n + 12 * m;
    return calcData.multiplier * Math.pow(data.weight, calcData.exp) + data.weight * c * calcData.lactationWeekMultiplier[data.lactationWeek];
  }
};
/* Puppy */

rules.puppy = {
  name: 'puppy',
  data: {
    getMaxMonths: function getMaxMonths(weight) {
      if (!(weight > 0)) return;
      var size = getWeigthSize(weight);

      switch (size) {
        case 'mini':
        case 'small':
          return 10;

        case 'medium':
          return 12;

        case 'big':
          return 15;

        case 'giant':
          return 18;
      }
    },
    const: 254,
    multiplier: 135,
    exp: 0.75
  },
  requiredFields: ['weight', 'actualWeight', 'age'],
  test: function test(data) {
    var maxMonths = rules.puppy.data.getMaxMonths(data.weight);
    return data.weight > 0 && data.age > 0 && data.age <= maxMonths;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    if (!rules.puppy.test(data)) throw 'Inform a valid puppy data.';
    if (!(data.actualWeight > 0)) throw 'Inform a valid actual weight.';
    if (parseInt(data.weight) < parseInt(data.actualWeight)) throw 'Actual weight cannot be bigger than adult weight.';
    return (rules.puppy.data.const - rules.puppy.data.multiplier * (data.actualWeight / data.weight)) * Math.pow(data.actualWeight, rules.puppy.data.exp);
  }
};
/* Senior */

rules.senior = {
  name: 'senior',
  data: {
    sizeMinAges: {
      'mini': 7 * 12,
      'small': 7 * 12,
      'medium': 7 * 12,
      'big': 5 * 12,
      'giant': 5 * 12
    },
    multiplier: 95,
    exp: 0.75
  },
  requiredFields: ['weight', 'age'],
  test: function test(data) {
    return rules.senior.data.sizeMinAges[data.size] && data.weight > 0 && data.age > 0 && data.age >= rules.senior.data.sizeMinAges[data.size];
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return Math.pow(data.weight, rules.senior.data.exp) * rules.senior.data.multiplier;
  }
};
/* Adult */

rules.adult = {
  name: 'adult',
  data: {
    multiplier: 95,
    exp: 0.75
  },
  requiredFields: ['weight', 'age'],
  test: function test(data) {
    return !rules.puppy.test(data) && data.age > 0 && data.weight > 0 && !rules.senior.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return Math.pow(data.weight, rules.adult.data.exp) * rules.adult.data.multiplier;
  }
}; // DRY FOODS
// ----------------------------------------------------------------------------------------------------------

var dryFoods = [// light
{
  product: 'GRANPLUS MENU DOG LIGHT',
  image: 'GP_Menu_Cao_Adulto_Light_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 999,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Adulto_Light_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-adulto-light-frango-arroz/'
  }],
  em: 3.4,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'light' && ['mini', 'small', 'medium', 'big', 'giant'].indexOf(data.size) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Pregnant
{
  product: 'GRANPLUS PUPPY DOG MINI',
  image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 450,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-filhote-mini-frango-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GRANPLUS PUPPY DOG',
  image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
  variations: [{
    id: 537,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-filhote-carne-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, // Lactating
{
  product: 'GRANPLUS PUPPY DOG MINI',
  image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 450,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-filhote-mini-frango-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'lactating' && ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GRANPLUS PUPPY DOG',
  image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
  variations: [{
    id: 537,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-filhote-carne-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return data.specialNeeds === 'lactating' && ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, // Puppy
{
  product: 'GRANPLUS PUPPY DOG MINI',
  image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 450,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Filhote_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-filhote-mini-frango-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GRANPLUS CHOICE PUPPY DOG',
  image: 'GP_Choice_Cao_Filhote_Sabor_Frango_e_Carne_FRONTAL.png',
  variations: [{
    // id: 450,
    product: 'CHICKEN & MEAT',
    image: 'GP_Choice_Cao_Filhote_Sabor_Frango_e_Carne_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/choice-cao-filhote-frango-carne/'
  }],
  em: 3.5,
  type: 'Choice',
  test: function test(data) {
    return ['mini', 'small', 'medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GRANPLUS GOURMET PUPPY DOG MINI',
  image: 'GP_Gourmet_Cao_Filhote_Mini_Sabor_Ovelha_e_Arroz_FRONTAL.png',
  variations: [{
    // id: 450,
    product: 'SHEEP & RICE',
    image: 'GP_Gourmet_Cao_Filhote_Mini_Sabor_Ovelha_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-filhote-mini-ovelha-arroz/'
  }],
  em: 3.8,
  type: 'Gourmet',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GRANPLUS PUPPY DOG',
  image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
  variations: [{
    id: 537,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Cao_Filhote_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-filhote-carne-arroz/'
  }],
  em: 3.9,
  type: 'Menu',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GRANPLUS GOURMET PUPPY DOG',
  image: 'GP_Gourmet_Cao_Filhote_Sabor_Ovelha_e_Arroz_FRONTAL.png',
  variations: [{
    // id: 537,
    product: 'SHEEP & RICE',
    image: 'GP_Gourmet_Cao_Filhote_Sabor_Ovelha_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-filhote-ovelha-arroz/'
  }],
  em: 3.54,
  type: 'Gourmet',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, // Senior
{
  product: 'GRANPLUS MENU SENIOR DOG',
  image: 'GP_Menu_Cao_Senior_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    //id: 380, 
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Senior_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-senior-frango-arro/'
  }],
  em: 3.7,
  type: 'Menu',
  test: function test(data) {
    return ['mini', 'small', 'medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.senior.test(data);
  }
}, // Adult
{
  product: 'GRANPLUS GOURMET ADULT DOG MEDIUM',
  image: 'GP_Gourmet_Cao_Adulto_Medio_e_Grande_Sabor_Ovelha_e_Arroz_FRONTAL.png',
  variations: [{
    //id: 623, 
    product: 'SHEEP & RICE',
    image: 'GP_Gourmet_Cao_Adulto_Medio_e_Grande_Sabor_Ovelha_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-medio-e-grande-ovelha-arr/'
  }, {
    //id: 623, 
    product: 'TURKEY & RICE',
    image: 'GP_Gourmet_Cao_Adulto_Medio_e_Grande_Sabor_Peru_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-medio-e-grande-peru-arroz/'
  }, {
    //id: 623, 
    product: 'SALMON & CHICKEN',
    image: 'GP_Gourmet_Cao_Adulto_Medio_e_Grande_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-medio-e-grande-salmao-frango/'
  }],
  em: 3.8,
  type: 'Gourmet',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds == '';
  }
}, {
  product: 'GRANPLUS GOURMET ADULT DOG MINI',
  image: 'GP_Gourmet_Cao_Adulto_Mini_Sabor_Ovelha_e_Arroz_FRONTAL.png',
  variations: [{
    id: 623,
    product: 'SHEEP & RICE',
    image: 'GP_Gourmet_Cao_Adulto_Mini_Sabor_Ovelha_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-mini-ovelha-arroz/'
  }, {
    //id: 623, 
    product: 'TURKEY & RICE',
    image: 'GP_Gourmet_Cao_Adulto_Mini_Sabor_Peru_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-mini-adulto-peru-arroz/'
  }, {
    id: 806,
    product: 'SALMON & CHICKEN',
    image: 'GP_Gourmet_Cao_Adulto_Mini_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-mini-salmao-frango/'
  }],
  em: 3.8,
  type: 'Gourmet',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds == '';
  }
}, {
  product: 'GRANPLUS ADULT DOG',
  image: 'GP_Menu_Cao_Adulto_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 608,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Adulto_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-adulto-frango-arroz/'
  }, {
    id: 567,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Cao_Adulto_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-adulto-carne-arroz/'
  }],
  em: 3.8,
  type: 'Menu',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds == '';
  }
}, {
  product: 'GRANPLUS MENU ADULT DOG MINI',
  image: 'GP_Menu_Cao_Adulto_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
  variations: [{
    id: 556,
    product: 'CHICKEN & RICE',
    image: 'GP_Menu_Cao_Adulto_Mini_Sabor_Frango_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-mini-frango-arroz/'
  }, {
    id: 549,
    product: 'MEAT & RICE',
    image: 'GP_Menu_Cao_Adulto_Mini_Sabor_Carne_e_Arroz_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/menu-cao-adulto-mini-carne-arroz/'
  }],
  em: 3.8,
  type: 'Menu',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds == '';
  }
}, // Choice
{
  product: 'GRANPLUS CHOICE ADULT DOG',
  image: 'GP_Choice_Cao_Adulto_Sabor_Frango_e_Carne_FRONTAL.png',
  variations: [{
    id: 351,
    product: 'CHICKEN & MEAT',
    image: 'GP_Choice_Cao_Adulto_Sabor_Frango_e_Carne_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/cao-adulto-frango-carne/'
  }],
  em: 3.65,
  type: 'Choice',
  test: function test(data) {
    return rules.adult.test(data) && data.specialNeeds == '';
  }
}]; // SACHETS
// ----------------------------------------------------------------------------------------------------------

var sachets = [// Gourmet
{
  product: 'GRANPLUS GOURMET HUMID FOOD ADULT DOG',
  image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Ovelha_FRONTAL.png',
  variations: [{
    //id: -1, 
    product: 'SHEEP',
    image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Ovelha_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-ovelha/'
  }, {
    //id: -1, 
    product: 'SALMON & CHICKEN',
    image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Salmao_e_Frango_FRONTAL.png',
    link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-salmao-frango/'
  }, {
    //id: -1, 
    product: 'SALMON',
    image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Salmao_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-salmao/',

  }, {
    //id: -1, 
    product: 'CHICKEN',
    image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Frango_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-frango/',

  }, {
    //id: -1, 
    product: 'MEAT',
    image: 'GP_Sache_Gourmet_Cao_Adulto_Sabor_Carne_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-cao-adulto-carne/',

  }],
  em: 0.7,
  grams: 100,
  type: 'Gourmet',
  test: function test(data) {
    return (data.specialNeeds == '' || data.specialNeeds == 'light') && rules.adult.test(data) || rules.senior.test(data);
  }
}, {
  product: 'GRANPLUS GOURMET HUMID FOOD PUPPY DOG',
  image: 'GP_Sache_Gourmet_Cao_Filhote_Sabor_Frango_FRONTAL.png',
  variations: [{
    //id: -1, 
    product: 'CHICKEN',
    image: 'GP_Sache_Gourmet_Cao_Filhote_Sabor_Frango_FRONTAL.png' // link: 'https://granplus.com.br/produtos/gourmet-cao-filhote-frango/',

  }],
  em: 0.8,
  grams: 100,
  type: 'Gourmet',
  test: function test(data) {
    return rules.puppy.test(data); // || ((data.specialNeeds == 'lactating' || data.specialNeeds == 'pregnant') &&  rules.adult.test(data))
  }
}];
dryFoods.forEach(function (f) {
  console.log(f.product); // f.variations.forEach(v => {
  //     console.log(f.product + ' ' + v.product)
  // })
});
sachets.forEach(function (f) {
  console.log(f.product); // f.variations.forEach(v => {
  //     console.log(f.product + ' ' + v.product)
  // })
}); // ----------------------------------------------------------------------------------------------------------

function getRule(data) {
  data.size = getWeigthSize(data.weight);
  var rule;

  for (var i = 0; i < rulesTestPriority.length; i++) {
    var curRule = rulesTestPriority[i];

    if (rules[curRule] && rules[curRule].test && rules[curRule].test(data)) {
      rule = rules[curRule];
      console.log('Calculating as ' + curRule);
      break;
    }
  }

  return rule;
}

function roundSachets(sachets) {
  return Math.ceil(Math.round(sachets * 10) / 10 / 0.5) * 0.5;
}

function getResult(data) {
  var rule = getRule(data);
  if (!rule) throw 'Calculation rule not registered.';
  var dryFoodsOpts = {};
  dryFoods.forEach(function (dryFood) {
    if (!dryFoodsOpts[dryFood.type] && dryFood.em > 0 && dryFood.test(data)) dryFoodsOpts[dryFood.type] = dryFood;
  });
  var sachetsOpts = {};
  sachets.forEach(function (sachet) {
    if (!sachetsOpts[sachet.type] && sachet.em > 0 && sachet.test(data)) sachetsOpts[sachet.type] = sachet;
  });
  var result = {
    type: 'dog',
    rule: rule.name,
    nem: rule.getNEM(data),
    dryFoods: dryFoodsOpts,
    sachets: sachetsOpts,
    diets: {}
  };

  if (result.nem > 0) {
    // Dry
    $.each(dryFoodsOpts, function (f, dryFood) {
      result.diets.dryFoods = result.diets.dryFoods || {};
      if (result.diets.dryFoods[dryFood.type]) return;
      result.diets.dryFoods[dryFood.type] = {
        dryFood: dryFood,
        grams: result.nem / dryFood.em
      };
    }); // Sachet

    $.each(sachetsOpts, function (s, sachet) {
      result.diets.sachets = result.diets.sachets || {};
      if (result.diets.sachets[sachet.type]) return;
      result.diets.sachets[sachet.type] = {
        sachet: sachet,
        quantity: Math.max(0.5, roundSachets(result.nem / sachet.em / sachet.grams))
      };
    });
  }

  console.log(result);
  return result;
}

module.exports = {
  brand: 'GP',
  name: 'cão',
  getRule: getRule,
  getResult: getResult,
  races: races //rules: rules,
  //dryFoods: dryFoods,
  //sachets: sachets,

};

},{}],11:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

;

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Calc = factory();
})(void 0, function () {
  var Calc = {};
  Calc.Calcs = {
    dog: require('./_calc-dog'),
    cat: require('./_calc-cat')
  };
  /**
   * Pet type names
   */

  Calc.PetType = {};

  for (var i = 0; i < Object.keys(Calc.Calcs).length; i++) {
    var key = Object.keys(Calc.Calcs)[i];
    Calc.PetType[key] = Calc.Calcs[key].name;
  }
  /**
   * Get results from pet information
   *
   * @param {string} petType
   * @param {object} petData
   *
   * @returns {object}
   */


  Calc.CalculateResults = function (petType, petData) {
    if (!Calc.PetType[petType] || !Calc.Calcs[petType]) throw 'The type of pet informed is unknown';
    if (!petData || Object.keys(petData).length == 0) throw 'The pet data is empty';
    return Calc.Calcs[petType].calc(petData);
  };

  return Calc;
});

},{"./_calc-cat":9,"./_calc-dog":10,"@babel/runtime/helpers/interopRequireDefault":2,"@babel/runtime/helpers/typeof":3}],12:[function(require,module,exports){
"use strict";

var router = require('./_routes_setup'); // Page loaded


document.addEventListener('pageLoaded', function (evt) {
  if (!evt.detail || !evt.detail.page) return;
  var page = evt.detail.page;

  switch (page.uri.replace(/\/.*/, '')) {
    case '':
      require('./_home').setup();

      break;
  }
}); // INITIAL SETUP

window.addEventListener('load', function () {
  // Languages
  var params = new Map((window.location.search || '').replace(/^\?/, '').split('&').map(function (p) {
    return p.split('=');
  }));
  var cookieLangParam = (document.cookie.match(/pll_language=([^;]+).*/) || [])[1];
  var preferredLang = (params.get('lang') || cookieLangParam != '' && cookieLangParam || navigator.language || navigator.userLanguage || 'en').toLowerCase();
  window.lang = new Lang();
  lang.dynamic('pt-br', 'assets/lang/pt-br.json');
  lang.dynamic('es', 'assets/lang/es.json');
  lang.init({
    defaultLang: 'en',
    currentLang: preferredLang,
    cookie: {
      name: 'lngc',
      expiry: 365,
      path: '/'
    },
    allowCookieOverride: !params.get('lang')
  });
  $(lang).on('afterUpdate', function () {// document.title = lang.translate('Biofresh | Daily Amount');
  }); // Start Listener

  router.addUriListener(); // Load first page

  router.navigateTo(location.pathname); // PLay intro

  playIntro();
});

function playIntro() {
  var $intro = $('.cz-intro');
  var $introBg = $('.cz-intro__bg');
  var $introLogo = $('.cz-intro__logo');
  var $saquinhos = $('.cz-saquinhos');
  var $fotoSteps1 = $('.cz-step-1 .cz-photo-pet');
  var $step1Title = $('.cz-step-1 .cz-title, .cz-step-1 .cz-btn');
  var tlIntro = new TimelineMax();
  tlIntro.from($introBg, 1, {
    backgroundColor: '#ffffff'
  }).from($introLogo, .5, {
    opacity: 0,
    yPercent: 100
  }, .5).to($introLogo, .6, {
    delay: 1,
    opacity: 0
  }).to($introBg, 1, {
    yPercent: -100
  }, 2).set($intro, {
    autoAlpha: 0
  }).from($saquinhos, .5, {
    opacity: 0
  }).from($fotoSteps1, .5, {
    opacity: 0,
    scale: .5
  }).from($step1Title, .5, {
    opacity: 0
  });
}

module.exports = {
  router: router
};

},{"./_home":6,"./_routes_setup":7}],13:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* https://github.com/Graidenix/vanilla-router */

/* global window, module */
;

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Router = factory();
})(void 0, function () {
  /**
   * Router
   *
   * @version: 1.2.7
   * @author Graidenix
   *
   * @constructor
   *
   * @param {object} options
   * @returns {Router}
   */
  function Router(options) {
    var settings = this._getSettings(options);

    this.notFoundHandler = settings.page404;
    this.mode = !window.history || !window.history.pushState ? "hash" : settings.mode;
    this.root = settings.root === "/" ? "/" : "/" + this._trimSlashes(settings.root) + "/";
    this.beforeHook = settings.hooks.before;
    this.securityHook = settings.hooks.secure;
    this.routes = [];

    if (settings.routes && settings.routes.length > 0) {
      var _this = this;

      settings.routes.forEach(function (route) {
        _this.add(route.rule, route.handler, route.options);
      });
    }

    this._pageState = null;
    this._previousPage = null;
    this._currentPage = null;
    this._skipCheck = false;
    this._action = null;

    if (this.mode === "hash") {
      this._historyStack = [];
      this._historyIdx = 0;
      this._historyState = "add";
    }

    return this;
  }
  /**
   * Define Router Page
   *
   * @param {string} uri
   * @param {object} query
   * @param {Array} params
   * @param {object} state
   * @param {object} options
   *
   * @constructor
   */


  Router.Page = function (uri, query, params, state, options) {
    this.uri = uri || "";
    this.query = query || {};
    this.params = params || [];
    this.state = state || null;
    this.options = options || {};
  };
  /**
   * Sanitize options and add default values
   *
   * @param {object} options
   * @returns {object}
   * @private
   */


  Router.prototype._getSettings = function (options) {
    var settings = {};
    var defaults = {
      routes: [],
      mode: "history",
      root: document.querySelector('base') ? document.querySelector('base').getAttribute('href') : "/",
      hooks: {
        "before": function before() {},
        "secure": function secure() {
          return true;
        }
      },
      page404: function page404(page) {
        console.error({
          page: page,
          message: "404. Page not found"
        });
      }
    };
    options = options || {};
    ["routes", "mode", "root", "page404"].forEach(function (key) {
      settings[key] = options[key] || defaults[key];
    });
    settings.hooks = Object.assign({}, defaults.hooks, options.hooks || {});
    return settings;
  };
  /**
   * Get URI for Router "history" mode
   *
   * @private
   * @returns {string}
   */


  Router.prototype._getHistoryFragment = function () {
    var fragment = decodeURI(window.location.pathname);

    if (this.root !== "/") {
      fragment = fragment.replace(this.root, "");
    }

    return this._trimSlashes(fragment);
  };
  /**
   * Get URI for router "hash" mode
   *
   * @private
   * @returns {string}
   */


  Router.prototype._getHashFragment = function () {
    var hash = window.location.hash.substr(1).replace(/(\?.*)$/, "");
    return this._trimSlashes(hash);
  };
  /**
   * Get current URI
   *
   * @private
   * @returns {string}
   */


  Router.prototype._getFragment = function () {
    if (this.mode === "history") {
      return this._getHistoryFragment();
    } else {
      return this._getHashFragment();
    }
  };
  /**
   * Trim slashes for path
   *
   * @private
   * @param {string} path
   * @returns {string}
   */


  Router.prototype._trimSlashes = function (path) {
    if (typeof path !== "string") {
      return "";
    }

    return path.toString().replace(/\/$/, "").replace(/^\//, "");
  };
  /**
   * 404 Page Handler
   *
   * @private
   */


  Router.prototype._page404 = function (path) {
    this._previousPage = this._currentPage;
    this._currentPage = new Router.Page(path);
    this.notFoundHandler(path);
  };
  /**
   * Convert the string route rule to RegExp rule
   *
   * @param {string} route
   * @returns {RegExp}
   * @private
   */


  Router.prototype._parseRouteRule = function (route) {
    if (typeof route !== "string") {
      return route;
    }

    var uri = this._trimSlashes(route);

    var rule = uri.replace(/([\\\/\-\_\.])/g, "\\$1").replace(/\{[a-zA-Z]+\}/g, "(:any)").replace(/\:any/g, "[\\w\\-\\_\\.]+").replace(/\:word/g, "[a-zA-Z]+").replace(/\:num/g, "\\d+");
    return new RegExp("^" + rule + "$", "i");
  };
  /**
   * Parse query string and return object for it
   *
   * @param {string} query
   * @returns {object}
   * @private
   */


  Router.prototype._parseQuery = function (query) {
    var _query = {};

    if (typeof query !== "string") {
      return _query;
    }

    if (query[0] === "?") {
      query = query.substr(1);
    }

    this._queryString = query;
    query.split("&").forEach(function (row) {
      var parts = row.split("=");

      if (parts[0] !== "") {
        if (parts[1] === undefined) {
          parts[1] = true;
        }

        _query[decodeURIComponent(parts[0])] = parts[1];
      }
    });
    return _query;
  };
  /**
   * Get query for `history` mode
   *
   * @returns {Object}
   * @private
   */


  Router.prototype._getHistoryQuery = function () {
    return this._parseQuery(window.location.search);
  };
  /**
   * Get query for `hash` mode
   *
   * @returns {Object}
   * @private
   */


  Router.prototype._getHashQuery = function () {
    var index = window.location.hash.indexOf("?");
    var query = index !== -1 ? window.location.hash.substr(index) : "";
    return this._parseQuery(query);
  };
  /**
   * Get query as object
   *
   * @private
   * @returns {Object}
   */


  Router.prototype._getQuery = function () {
    if (this.mode === "history") {
      return this._getHistoryQuery();
    } else {
      return this._getHashQuery();
    }
  };
  /**
   * Add route to routes list
   *
   * @param {string|RegExp} rule
   * @param {function} handler
   * @param {{}} options
   * @returns {Router}
   */


  Router.prototype.add = function (rule, handler, options) {
    this.routes.push({
      rule: this._parseRouteRule(rule),
      handler: handler,
      options: options
    });
    return this;
  };
  /**
   * Remove a route from routes list
   *
   * @param param
   * @returns {Router}
   */


  Router.prototype.remove = function (param) {
    var _this = this;

    if (typeof param === "string") {
      param = this._parseRouteRule(param).toString();
    }

    this.routes.some(function (route, i) {
      if (route.handler === param || route.rule.toString() === param) {
        _this.routes.splice(i, 1);

        return true;
      }

      return false;
    });
    return this;
  };
  /**
   * Reset the state of Router
   *
   * @returns {Router}
   */


  Router.prototype.reset = function () {
    this.routes = [];
    this.mode = null;
    this.root = this.root || (document.querySelector('base') ? document.querySelector('base').getAttribute('href') : "/");
    this._pageState = {};
    this.removeUriListener();
    return this;
  };
  /**
   * Add current page in history stack
   * @private
   */


  Router.prototype._pushHistory = function () {
    var _this = this,
        fragment = this._getFragment();

    if (this.mode === "hash") {
      if (this._historyState === "add") {
        if (this._historyIdx !== this._historyStack.length - 1) {
          this._historyStack.splice(this._historyIdx + 1);
        }

        this._historyStack.push({
          path: fragment,
          state: _this._pageState
        });

        this._historyIdx = this._historyStack.length - 1;
      }

      this._historyState = "add";
    }
  };
  /**
   *
   * @param asyncRequest boolean
   * @returns {PromiseResult<boolean> | boolean}
   * @private
   */


  Router.prototype._unloadCallback = function (asyncRequest) {
    var result;

    if (this._skipCheck) {
      return asyncRequest ? Promise.resolve(true) : true;
    }

    if (this._currentPage && this._currentPage.options && this._currentPage.options.unloadCb) {
      result = this._currentPage.options.unloadCb(this._currentPage, asyncRequest);

      if (!asyncRequest || result instanceof Promise) {
        return result;
      }

      return result ? Promise.resolve(result) : Promise.reject(result);
    } else {
      return asyncRequest ? Promise.resolve(true) : true;
    }
  };
  /**
   * Check if router has the action for current path
   *
   * @returns {boolean}
   * @private
   */


  Router.prototype._findRoute = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _this2 = this;

    var _this, fragment;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _this = this, fragment = this._getFragment();
            return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(resolve, reject) {
                var _iterator, _step, route, match, query, page, result;

                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iterator = _createForOfIteratorHelper(_this2.routes);
                        _context.prev = 1;

                        _iterator.s();

                      case 3:
                        if ((_step = _iterator.n()).done) {
                          _context.next = 28;
                          break;
                        }

                        route = _step.value;
                        match = fragment.match(route.rule);

                        if (!match) {
                          _context.next = 26;
                          break;
                        }

                        match.shift();
                        query = _this._getQuery();
                        page = new Router.Page(fragment, query, match, _this._pageState, route.options);

                        if (_this.securityHook(page)) {
                          _context.next = 12;
                          break;
                        }

                        return _context.abrupt("return", false);

                      case 12:
                        if (_this2._currentPage && page && page.uri != _this2._currentPage.uri) _this2._previousPage = _this2._currentPage;
                        _this._currentPage = page;

                        if (!_this._skipCheck) {
                          _context.next = 17;
                          break;
                        }

                        _this._skipCheck = false;
                        return _context.abrupt("return", true);

                      case 17:
                        _this.beforeHook(page);

                        _context.next = 20;
                        return route.handler.apply(page, match);

                      case 20:
                        result = _context.sent;
                        _this._pageState = null;

                        window.onbeforeunload = function (ev) {
                          if (_this._unloadCallback(false)) {
                            return;
                          }

                          ev.returnValue = true;
                          return true;
                        };

                        if (!result) {
                          _context.next = 26;
                          break;
                        }

                        resolve();
                        return _context.abrupt("break", 28);

                      case 26:
                        _context.next = 3;
                        break;

                      case 28:
                        _context.next = 33;
                        break;

                      case 30:
                        _context.prev = 30;
                        _context.t0 = _context["catch"](1);

                        _iterator.e(_context.t0);

                      case 33:
                        _context.prev = 33;

                        _iterator.f();

                        return _context.finish(33);

                      case 36:
                        reject();

                      case 37:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[1, 30, 33, 36]]);
              }));

              return function (_x, _x2) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  /**
   *
   */

  Router.prototype._treatAsync = function () {
    var result;
    result = this._currentPage.options.unloadCb(this._currentPage, true);

    if (!(result instanceof Promise)) {
      result = result ? Promise.resolve(result) : Promise.reject(result);
    }

    result.then(this._processUri.bind(this)).catch(this._resetState.bind(this));
  };
  /**
   *
   * @private
   */


  Router.prototype._resetState = function () {
    this._skipCheck = true;
    this.navigateTo(this._current, this._currentPage.state, true);
  };
  /**
   * Replace current page with new one
   */


  Router.prototype._processUri = function () {
    var _this3 = this;

    var fragment = this._getFragment(),
        found;

    this._current = fragment;

    this._pushHistory();

    this._findRoute.call(this).catch(function (err) {
      _this3._page404(fragment);
    });
  };
  /**
   * Check the URL and execute handler for its route
   *
   * @returns {Router}
   */


  Router.prototype.check = function () {
    if (this._skipCheck) return this; // if page has unload cb treat as promise

    if (this._currentPage && this._currentPage.options && this._currentPage.options.unloadCb) {
      this._treatAsync();
    } else {
      this._processUri();
    }

    return this;
  };
  /**
   * Add the URI listener
   *
   * @returns {Router}
   */


  Router.prototype.addUriListener = function () {
    if (this.mode === "history") {
      window.onpopstate = this.onPopState.bind(this);
    } else {
      window.onhashchange = this.check.bind(this);
    }

    return this;
  };

  Router.prototype.onPopState = function () {
    this._pageState = history.state;
    this.check();
  };
  /**
   * Remove the URI listener
   *
   * @returns {Router}
   */


  Router.prototype.removeUriListener = function () {
    window.onpopstate = null;
    window.onhashchange = null;
    return this;
  };
  /**
   * Redirect to a page with replace state
   *
   * @param {string} path
   * @param {object} state
   * @param {boolean} silent
   *
   * @returns {Router}
   */


  Router.prototype.redirectTo = function (path, state, silent) {
    path = this._trimSlashes(path) || "";
    this._pageState = state || null;
    this._skipCheck = !!silent;

    if (this.mode === "history") {
      var re = new RegExp('^\/?' + this._trimSlashes(this.root));
      history.replaceState(state, null, this.root + this._trimSlashes(this._trimSlashes(path).replace(re, '')));
      return this.check();
    } else {
      this._historyIdx--;
      window.location.hash = path;
    }

    return this;
  };
  /**
   * Navigate to a page
   *
   * @param {string} path
   * @param {object} state
   * @param {boolean} silent
   *
   * @returns {Router}
   */


  Router.prototype.navigateTo = function (path, state, silent) {
    path = this._trimSlashes(path) || "";
    this._pageState = state || null;
    this._skipCheck = !!silent;

    if (this.mode === "history") {
      var re = new RegExp('^\/?' + this._trimSlashes(this.root));
      history.pushState(state, null, this.root + this._trimSlashes(this._trimSlashes(path).replace(re, '')));
      return this.check();
    } else {
      window.location.hash = path;
    }

    return this;
  };
  /**
   * Refresh page with recall route handler
   * @returns {Router}
   */


  Router.prototype.refresh = function () {
    if (!this._currentPage) {
      return this;
    }

    var path = this._currentPage.uri + "?" + this._queryString;
    return this.navigateTo(path, this._currentPage.state);
  };
  /**
   * Go Back in browser history
   * Simulate "Back" button
   *
   * @returns {Router}
   */


  Router.prototype.back = function () {
    if (this.mode === "history") {
      window.history.back();
      return this;
    }

    return this.go(this._historyIdx - 1);
  };
  /**
   * Go Forward in browser history
   * Simulate "Forward" button
   *
   * @returns {Router}
   */


  Router.prototype.forward = function () {
    if (this.mode === "history") {
      window.history.forward();
      return this;
    }

    return this.go(this._historyIdx + 1);
  };
  /**
   * Go to a specific history page
   *
   * @param {number} count
   * @returns {Router}
   */


  Router.prototype.go = function (count) {
    if (this.mode === "history") {
      window.history.go(count);
      return this;
    }

    var page = this._historyStack[count];

    if (!page) {
      return this;
    }

    this._historyIdx = count;
    this._historyState = "hold";
    return this.navigateTo(page.path, page.state);
  };

  return Router;
});

},{"@babel/runtime/helpers/asyncToGenerator":1,"@babel/runtime/helpers/interopRequireDefault":2,"@babel/runtime/helpers/typeof":3,"@babel/runtime/regenerator":4}]},{},[12])(12)
});
